import I18nService from '@/services/i18n.service';
import PrintOSService from '@/services/PrintOS.service';
import { createApp } from 'vue';

export default class HelpersService {
  i18n = new I18nService();
  printOS = new PrintOSService();

  copyObject(object) {
    return object ? JSON.parse(JSON.stringify(object)) : null;
  }

  hasValue(item) {
    return item !== undefined && item !== null;
  }

  get(value, defaultValue) {
    if (this.hasValue(value)) {
      return value;
    }

    return defaultValue;
  }

  isEmpty(item) {
    return item !== undefined && item !== null && item.trim() !== '';
  }

  mountVueComponent(vm, content, propsData = {}) {
    const tempDiv = document.createElement('div');
    let instance = createApp(content, propsData);
    instance.use(this.i18n.store.i18n);
    instance.mount(tempDiv);
    return tempDiv;
  }
}
